import React from 'react';

import styles from './ItemCard.module.css';
import { Itinerary } from 'models/itinerary';
import { useSelector } from 'react-redux';
import { selectDigitalMap } from 'ducks/universal/digitalMap';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import { formattedTimeOfDay, formattedTravelTime } from 'components/Map/util';
interface ItemCardProps {
  item: Itinerary['date_itineraries'][number]['items'][number];
  onClick: () => void;
}

export const ItemCard: React.FC<ItemCardProps> = ({ item, onClick }) => {
  const digitalMap = useSelector(selectDigitalMap);
  const { t, i18n } = useTranslation();

  const pin = digitalMap?.pins.find((pin) => pin.key === item.pin_key);
  const thumbnailUrl = pin?.media_items?.find((media) => media.type === 'IMAGE')?.url;

  const hasTickets = !!pin?.associated_product_ids?.length;

  return (
    <div className={styles.card} onClick={onClick}>
      {thumbnailUrl && (
        <>
          {hasTickets && (
            <div className={styles.ticketBadge}>
              <img src="/static/images/map/ticket_white.svg" alt="Ticket" />
            </div>
          )}
          <div className={styles.cardContent}>
            <img src={thumbnailUrl} alt={pin?.title} className={styles.cardImage} />
          </div>
        </>
      )}
      <div className={styles.infoContainer}>
        <div className={styles.leftInfo}>
          <div className={clsx(styles.timeText, !item.time && styles.timeTextEmpty)}>
            {item.time ? formattedTimeOfDay(item.time, i18n.language) : t('No Time Selected')}
          </div>
          <div className={styles.titleText}>{pin?.title}</div>
        </div>
        <div className={styles.rightInfo}>
          <div className={styles.durationText}>{item.duration}</div>
          {item.travel_time !== '-' && (
            <div className={styles.walkContainer}>
              <img src="/static/images/map/walker_blue.svg" alt="" className={styles.walkIcon} />
              <div>{formattedTravelTime(item.travel_time, t)}</div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
